import { Box, Card, Typography, useTheme } from '@mui/material';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useEntityManagementViewModel } from '../hooks/useEntityManagementViewModel';

export const EntityManagementPage = () => {
  const { entities } = useEntityManagementViewModel();
  const { t } = useTranslation(['periverse']);
  const theme = useTheme();

  return (
    <Box sx={{ px: { xs: '1rem', md: '1.5rem', lg: '3rem', xl: '3rem' } }}>
    <Card
      sx={{
        borderRadius: '24px',
        boxShadow: 'rgba(0, 0, 0, 0.08) 0px 1px 8px 0px',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        {entities.map((entity, i) => (
          <Box
            component={Link}
            to={entity.to}
            key={entity.labelKey}
            sx={{
              display: 'flex',
              height: '76px',
              width: '100%',
              alignItems: 'center',
              padding: '20px',
              borderBottom:
                i < entities.length - 1
                  ? `1px solid ${theme.palette.divider}`
                  : 'none',
              '&:hover': {
                textDecoration: 'none',
                backgroundColor: 'action.hover',
              },
            }}
          >
            <Typography fontWeight={500}>{t(entity.labelKey)}</Typography>
          </Box>
        ))}
      </Box>
    </Card>
    </Box>
  );
};
